// src/components/AskQuestionForm.jsx
import React, { Fragment, useState, useEffect } from 'react';
import {checkToken} from '../../Authentication/AxiosInstance';
import { useUser } from "../../store/UserContext";
import {jwtDecode} from 'jwt-decode';

const AskQuestionForm = ({ onSubmit, onCancel }) => {
  const {user} = useUser();
  console.log(user)
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const buttonClass = `m-2 p-2 h-auto w-fit 
                  bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                  border-2 rounded-lg 
                  text-base font-bold tracking-widest normal-case items-center`;
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await checkToken.post('/api/forum/ask/',{ 
        "c002_query_subject": title, 
        "c002_query_description": description });
        if (onSubmit) {
          onSubmit(res.data);
        }
        setTitle('');
      setDescription('');
      setError('Your Query has been saved successfully')

    } catch (err) {
      console.error('Error submitting question:', err);
      if (err.response) {
        // Server responded with a status code outside the 2xx range
        setError(err.message)
      } else if (err.request) {
        // Request was made but no response
        setError("No response from server");
      } else {
        // Something else happened setting up the request
        setError("Your post could not be recorded: " + err);
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('access_token')  || sessionStorage.getItem('access_token');
    console.log(token)
    const decoded = token? jwtDecode(token) : null; // use jwt-decode package
    if (!token || (decoded?.exp * 1000 < Date.now())) {
      setError('Your session has expired. Please login again.')
    }
  }, [user]);

  return (
    <Fragment>
        <div className="text-danger-500 font-semibold font-nunito text-center">{error}</div>
        <form onSubmit={handleSubmit} className="bg-transparent rounded-xl shadow-lg space-y-3 mx-auto p-4 border-b border-tertiary-500">
          <input
            type="text"
            className="w-full border rounded-lg text-base"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title* (100 characters max)"
            required
          />
          <textarea
            className="w-full border rounded-lg text-base"
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Describe your query here.. (500 characters max)"
            maxLength="500"
          />
          <div className="flex justify-end">
            <button type="button"  onClick={onCancel}  className={`${buttonClass}`}>Cancel</button>
            <button type="submit"  className={`${buttonClass}`}>Submit</button>
          </div>
        </form>
        {console.log(error)}
        
    </Fragment>
  );
};

export default AskQuestionForm;
